import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController, useFocusOptionController } from '../../../internal/hooks/controllers';
import { SELECT_ALL_INDEX } from '../../../internal';
export function useMultiSelectDesktopController(props) {
  var _useDropdownControlle = useDropdownController(props),
    open = _useDropdownControlle.open,
    dropdownActions = _useDropdownControlle.actions;
  var _useFocusOptionContro = useFocusOptionController({
      length: props.options.length,
      minIndex: props.allOption ? SELECT_ALL_INDEX : 0
    }),
    focusedIndex = _useFocusOptionContro.focusedIndex,
    focusOptionActions = _useFocusOptionContro.actions;
  var stateRef = useValueRef({
    props: props,
    open: open,
    focusedIndex: focusedIndex
  });
  var allOptionLabel = React.useMemo(function () {
    if (!props.allOption) {
      return;
    }
    return typeof props.allOption === 'boolean' ? 'Выбрать всё' : props.allOption;
  }, [props.allOption]);
  React.useEffect(function () {
    var _stateRef$current$pro = stateRef.current.props,
      options = _stateRef$current$pro.options,
      value = _stateRef$current$pro.value;
    if (open) {
      return;
    }
    var firstIndex = props.allOption ? SELECT_ALL_INDEX : 0;
    var firstSelectedIndex = props.allOption && value.length === options.length ? SELECT_ALL_INDEX : options.findIndex(function (option) {
      return value.includes(option.value);
    });
    focusOptionActions.setFocusedIndex(Math.max(firstSelectedIndex, firstIndex));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, props.allOption]);
  var setFocusedOptionState = function setFocusedOptionState(nextState) {
    var _stateRef$current = stateRef.current,
      props = _stateRef$current.props,
      focusedIndex = _stateRef$current.focusedIndex;
    var option = props.options[focusedIndex];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    var isChecked = prevValue.includes(optionValue);
    if (isChecked === nextState) {
      return;
    }
    if (nextState) {
      props.onChange([].concat(_toConsumableArray(prevValue), [optionValue]));
    } else {
      props.onChange(prevValue.filter(function (v) {
        return v !== optionValue;
      }));
    }
  };
  var toggleAllOptionState = function toggleAllOptionState() {
    var props = stateRef.current.props;
    var allValues = props.options.map(function (option) {
      return option.value;
    });
    var newValue = props.value.length === props.options.length ? [] : allValues;
    props.onChange(newValue);
  };
  var toggleOptionState = function toggleOptionState(index) {
    var props = stateRef.current.props;
    var option = props.options[index];
    if (!option) {
      return;
    }
    var optionValue = option.value;
    var prevValue = props.value;
    var isChecked = prevValue.includes(optionValue);
    if (isChecked) {
      props.onChange(prevValue.filter(function (v) {
        return v !== optionValue;
      }));
    } else {
      props.onChange([].concat(_toConsumableArray(prevValue), [optionValue]));
    }
  };
  var toggleFocusedOptionState = function toggleFocusedOptionState() {
    var focusedIndex = stateRef.current.focusedIndex;
    if (focusedIndex === SELECT_ALL_INDEX) {
      toggleAllOptionState();
    } else {
      toggleOptionState(stateRef.current.focusedIndex);
    }
  };
  var actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusOptionActions), {}, {
    setFocusedOptionState: setFocusedOptionState,
    toggleFocusedOptionState: toggleFocusedOptionState,
    toggleOptionState: toggleOptionState,
    toggleAllOptionState: toggleAllOptionState
  });
  return {
    open: open,
    focusedIndex: focusedIndex,
    actions: actions,
    allOptionLabel: allOptionLabel
  };
}